<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              depressed
              dark
              color="#1B437C"
              @click="alert=!alert,chkAdd(),(dialogAdd = true), validate('ADD'), getDataBranch(), chkaddFilterItem(), chkaddProductExchangeRate()"
            >
              <v-icon left>mdi-plus-box-multiple</v-icon>
              Add Lot
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-dialog v-model="dialogAdd" persistent max-width="50%">
            <v-card class="text-center">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click=";(dialogAdd = false), clearData()"
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row justify="center">
                    <v-col cols="4" class="text-center">
                      <v-col class="text-center">
                        <v-img
                          class="v-margit_img_reward"
                          :src="require('@/assets/Device.svg')"
                          max-width="330"
                        ></v-img>
                      </v-col>
                    </v-col>

                    <v-col cols="8" class="v-margit_text_add">
                      <v-col class="text-center">
                        <v-img
                          class="v_text_add"
                          :src="require('@/assets/Grouptitle.svg')"
                        ></v-img>
                      </v-col>
                      <v-alert
                        v-if="res.length >= 10"
                        :value="alert"
                        outlined
                        type="warning"
                        prominent
                        border="left"
                        elevation="24"
                        >
                        จำนวนสมาชิกใกล้จะครบที่กำหนด
                    </v-alert>
                    <v-card
                    max-width="600"
                    class="mx-auto"
                    v-show="this.formAdd.productExchangeRateId === ''"
                    v-if="session.data.userTypeGroup === 'Operation'"
                  >
                  <!-- {{ProductExchangeRate}} -->
                    <v-container>
                      <v-row dense pt-3>
                        <v-col
                          v-for="(item, i) in filterItem"
                          :key="i"
                          cols="6"
                        >
                          <div>
                            <v-card color="#1b437c" dark>
                              <!-- {{filterItem}} -->
                              <v-card-title>
                                <h2>
                                  {{ item.text }}
                                </h2>
                              </v-card-title>
                              <div
                                class="d-flex flex-no-wrap justify-space-between"
                              >
                                <div>
                                  <v-card-subtitle>
                                    <h5>
                                      อัตราแลกเปลี่ยน 1 คะแนน ต่อ
                                      {{ item.exchangeRate }} บาท
                                    </h5>
                                  </v-card-subtitle>
                                </div>
                              </div>
                              <v-card-actions>
                                <v-btn
                                  class="mx-auto"
                                  text
                                  color="primary"
                                  @click="addExchange(item), getDataBranch()"
                                >
                                  เลือก
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                    <v-card
                    max-width="600"
                    class="mx-auto"
                    v-show="this.formAdd.productExchangeRateId === ''"
                    v-if="session.data.userTypeGroup !== 'Operation'"
                  >
                  <!-- {{session.data.userTypeGroup}} -->
                    <v-container>
                      <v-row dense pt-3>
                        <v-col
                          v-for="(item, i) in ProductExchangeRate"
                          :key="i"
                          cols="6"
                        >
                          <div class="box" @click="addExchange(item)">
                            <v-card color="#1b437c" dark class="pa-4">
                              <!-- {{ProductExchangeRate}} -->
                              <v-card-title>
                                <h3 class="mb-0">
                                  {{ item.text }}
                                </h3>
                              </v-card-title>
                              <div
                                class="d-flex flex-no-wrap justify-space-between"
                              >
                                <div>
                                  <v-card-subtitle>
                                    <h5 style="text-align: left;">
                                      อัตราแลกเปลี่ยน 1 คะแนน ต่อ
                                      {{ item.exchangeRate }} บาท
                                    </h5>
                                  </v-card-subtitle>
                                </div>
                              </div>
                              <v-btn
                                  class="mx-auto"
                                  outlined
                                  @click="addExchange(item)"
                                >
                                  เลือก
                                </v-btn>
                              <!-- <v-card-actions>
                              </v-card-actions> -->
                            </v-card>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                      <v-form ref="form_add" v-model="validAdd" lazy-validation v-show="this.formAdd.productExchangeRateId !== ''">
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <v-text-field
                              v-model="formAdd.lotName"
                              label="ชื่อ Lot"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <v-text-field
                              disabled
                              v-model="Exchange"
                              :items="Exchange"
                              dense
                              outlined
                              :rules="[rules.required]"
                              label="Exchange Rate"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <VuetifyMoney
                              v-model="formAdd.amount"
                              label="จำนวนเงิน"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <VuetifyMoney
                              v-model="formAdd.countLot"
                              label="จำนวน"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <v-select
                              v-model="formAdd.masBranchID"
                              :items="dataBranch"
                              label="สาขา"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col>
                      </v-form>
                      <v-col id="margin">
                        <v-row justify="center">
                          <v-btn
                            elevation="2"
                            x-large
                            dark
                            color="#173053"
                            :disabled="!validAdd"
                            :loading="loadingAdd"
                            @click="addData()"
                          >
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            เพิ่ม
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- View -->
          <v-dialog v-model="dialogViewQR" persistent max-width="80%">
            <v-card>
              <v-card-text>
                <v-form>
                  <v-container>
                    <v-row class="no-gutters">
                      <v-col
                        v-for="(items, index) in dataViewQR"
                        :key="index"
                        cols="2"
                        class="text-center ma-0 pa-6 frameQR"
                      >
                        <span class="shopname">{{ session.data.name }}</span>
                        <qrcode-vue
                          :value="items.qrCodeURL"
                          :size="size"
                          level="H"
                        ></qrcode-vue>
                        <span class="point">{{ items.point }}</span>
                        <span class="summary">คะแนน</span>
                        <br />
                        <span class="summary" color="#173053"
                          >*สแกนเพื่อรับคะแนน</span
                        >
                      </v-col>
                    </v-row>
                    <div></div>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogViewQR = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end View -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="30%">
            <v-card class="text-center">
              <v-card-text>
                <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn small color="#E0E0E0" @click="dialogEdit = false">
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-img
                          class="v-img-margit"
                          :src="require('@/assets/VectorEdit.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" class="v-margit_text_add">
                        <v-img
                          class="v_text"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-col cols="12">
                      <v-row style="height: 20px">
                        <v-subheader id="subtext">ชื่อ LOT</v-subheader>
                      </v-row>
                      <v-row style="height: 55px">
                        <v-col cols="12">
                          <v-text-field
                            v-model="formUpdate.lotName"
                            placeholder="ชื่อ Lot"
                            dense
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- dialog Printer -->
          <v-dialog v-model="dialogPrinter" persistent max-width="70%">
            <v-card>
              <iframe id="pdfV" style="width:100%; height: 1200px"> </iframe>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogPrinter = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.amount`]="{ item }">
                    {{ formatNumber(item.amount) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <v-btn
                     v-bind="attrs"
                          v-on="on"
                      class="btn-color"
                      fab
                      dark
                      x-small
                      @click.stop="
                        ;(dialogEdit = true),
                          getDataById(item),
                          validate('UPDATE')
                      "
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                     </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                     <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                          v-on="on"
                      class="btn-color"
                      fab
                      x-small
                      @click.stop=";(dialogViewQR = true), getDataQRCode(item)"
                    >
                      <v-icon dark color="green accent-3">
                        mdi-qrcode-scan
                      </v-icon>
                    </v-btn>
                     </template>
                      <span>เปิด Qr code</span>
                    </v-tooltip>
                     <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <v-btn
                     v-bind="attrs"
                          v-on="on"
                      color="primary"
                      dark
                      fab
                      x-small
                      @click.stop=";(dialogPrinter = true), printer(item)"
                    >
                      <v-icon> mdi-printer </v-icon>
                    </v-btn>
                     </template>
                      <span>ปริ้น Qr code</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
// import { QrcodeStream } from 'vue-qrcode-reader'
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'
import pdfMake from 'pdfmake'
import pdfFonts from '../../assets/my-fonts/custom-fonts.js' // 1. import custom fonts

// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue
    // QrcodeStream
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/qrcodeLot/', // Path Model
      returnLink: '/Tool/CollectQRCodeLot',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Collect QRCode Lot',
          disabled: false,
          href: '/Tool/CollectQRCodeLot'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      camera: 'auto',
      result: null,
      showScanConfirmation: false,
      formRedeem: {
        shopId: '',
        rewardId: '',
        rewardCode: '',
        lineUserId: '',
        totalPoint: '',
        levelName: ''
      },
      // End Menu Config
      dataReady: true,
      dataShowQR: false,
      dialogRedeem: false,
      dialogPrinter: false,
      size: 120, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      dialogViewLot: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogAddLot: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      dialogViewAdd: false,
      dialogViewQR: false,
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formView: {
        lineName: '',
        linePicture: '',
        rewardName: '',
        rewardSubName: '',
        rewardPictureUrl: ''
      },
      formAdd: {
        productExchangeRateId: '',
        amount: 0,
        point: 0,
        status: 'waiting',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        lotId: '',
        countLot: '',
        branchName: '',
        masBranchID: '',
        lotName: '',
        liffId: ''
      },
      formUpdate: {
        id: '',
        productExchangeRateId: '',
        amount: 0,
        point: 0,
        status: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        CREATE_DATE: '',
        LAST_DATE: '',
        lotId: '',
        branchName: '',
        masBranchID: '',
        lotName: ''
      },
      formUpdateItem: {
        lotName: ''
      },
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'Lot Id', value: 'lotId' },
        { text: 'Lot Name', value: 'lotName' },
        { text: 'รหัสของอัตราแลกเปลี่ยน', value: 'productExchangeRateId' },
        { text: 'Amount', value: 'amount' },
        { text: 'Count', value: 'Count' },
        { text: 'Get', value: 'Get' },
        { text: 'ใช้แล้ว', value: 'Use' },
        // { text: 'Status', value: 'point' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataViewQR: [],
      ProductExchangeRate: [],
      dataItem: [],
      dataItemViewLot: [],
      dataBranch: [],
      validAdd: true,
      validAddLot: true,
      validUpdate: true,
      dailogViewRedeem: false,
      statusViewRedeem: false,
      alert: false,
      res: [],
      filterItem: [],
      Exchange: '',
      print: [],
      loadingAdd: false,
      loadingEdit: false
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.getDataBranch()
    this.getProductExchangeRate()
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    await this.filter()
    // this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId + '&status=waiting')
    // console.log('xxxx', this.dataItem)
  },
  methods: {
    printer (item) {
      this.dataReady = false
      this.print = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/qrcode/' + 'get?status=waiting&lotId=' + item.lotId
        )
        .then(async response => {
          this.dataReady = true
          let printqr = response.data
          let qrcode = []
          for (let i = 0; i < printqr.length; i++) {
            let qr = printqr[i]
            let s = {}
            // let b = {}
            if (qr.qrCodeURL !== '') {
              s.qr = qr.qrCodeURL
              s.point = qr.point
              qrcode.push(s)
            //   b.text = ' '
            //   qrcode.push(b)
            }
          }
          console.log('qrcode', qrcode)
          let content = []
          let q = {columns: []}
          let arris3 = function () {
            return [{text: '   '}]
          }
          // console.log(q)
          qrcode.map((a, i) => {
            if (q.columns.length < 5) {
              q.columns.push([ { qr: a.qr, fit: '90', alignment: 'center' }, { text: 'จำนวน' + ' ' + a.point + ' ' + 'เหรียญ', alignment: 'center' } ])
              if (i === qrcode.length - 1) {
                content.push({columns: [...q.columns]})
                content.push(arris3())
              }
            } else if (q.columns.length > 4) {
              content.push({columns: [...q.columns]})
              content.push(arris3())
              q.columns = []
              q.columns.push([ { qr: a.qr, fit: '90', alignment: 'center' }, { text: 'จำนวน' + ' ' + a.point + ' ' + 'เหรียญ', alignment: 'center' } ])
            }
          })
          console.log('content', content)
          const docDefinition = {
            pageSize: 'A4',
            // pageOrientation: 'landscape',
            content: content,
            defaultStyle: { // 4. default style 'KANIT' font to test
              font: 'Kanit'
            }
          }
          pdfMake.vfs = pdfFonts.pdfMake.vfs // 2. set vfs pdf font
          pdfMake.fonts = {
            // download default Roboto font from cdnjs.com
            Roboto: {
              normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
              bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
              italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
              bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
            },
            // Kanit Font
            Kanit: { // 3. set Kanit font
              normal: 'Kanit-Regular.ttf',
              bold: 'Kanit-Medium.ttf',
              italics: 'Kanit-Italic.ttf',
              bolditalics: 'Kanit-MediumItalic.ttf'
            }
          }
          pdfMake.createPdf(docDefinition).getDataUrl(function (outDoc) {
            document.getElementById('pdfV').src = outDoc
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    chkaddFilterItem () {
      if (this.filterItem.length === 1) {
        this.addExchange(this.filterItem)
      }
    },
    chkaddProductExchangeRate () {
      if (this.ProductExchangeRate.length === 1) {
        this.addExchange(this.ProductExchangeRate)
      }
    },
    addExchange (item) {
      if (this.session.data.userTypeGroup === 'Operation') {
        if (this.filterItem.length === 1) {
          this.formAdd.productExchangeRateId = item[0].value
          this.Exchange = item[0].text
        } else {
          this.formAdd.productExchangeRateId = item.value
          this.Exchange = item.text
        }
      } else if (this.session.data.userTypeGroup !== 'Operation') {
        if (this.ProductExchangeRate.length === 1) {
          this.formAdd.productExchangeRateId = item[0].value
          this.Exchange = item[0].text
        } else {
          this.formAdd.productExchangeRateId = item.value
          this.Exchange = item.text
        }
      } else {
        this.formAdd.productExchangeRateId = item.value
        this.Exchange = item.text
      }

      console.log('item', item)
    },
    async filter () {
      this.filterItem = []
      this.ProductExchangeRate.forEach(element => {
        JSON.parse(element.userId).forEach(el => {
          if (el === this.session.data.userId) {
            this.filterItem.push(element)
          }
        })
      })
      console.log('oooo', this.filterItem)
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          console.log('getDataCompany : ', this.dataBranch)
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = s.value
            console.log('masBranch', this.formAdd.masBranchID)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'ADDLOT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_addLot.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getProductExchangeRate () {
      // Clear Data ทุกครั้ง
      this.ProductExchangeRate = []
      // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.session.data.shopId
          // {
          //   headers: {
          //     'Application-Key': this.$session.getAll().ApplicationKey
          //   }
          // }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            s.userId = d.userId
            d = s
            console.log(d)
            this.ProductExchangeRate.push(d)
          }
          // console.log('getDataTypeGroup : ', this.UserTypeGroup)
        })
      console.log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'id',
        item.id,
        this.returnLink
      )
    },
    async getDataQRCode (dt) {
      this.dataReady = false
      this.dataViewQR = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/qrcode/' + 'get?status=waiting&lotId=' + dt.lotId
        )
        .then(async response => {
          this.dataReady = true
          this.dataViewQR = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    async addData () {
      this.dataReady = false
      this.dataShowQR = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          const today = new Date()
          // console.log(today)
          const date =
            today.getFullYear() +
            '' +
            (today.getMonth() + 1) +
            '' +
            today.getDate()
          const time =
            today.getHours() + '' + today.getMinutes() + '' + today.getSeconds()
          const lotId = date + '' + time
          var productExchangeRateId = this.formAdd.productExchangeRateId

          var dateExchange = this.ProductExchangeRate.filter(function (el) {
            return el.value === productExchangeRateId
          })
          let _this = this
          var dateBranchs = this.dataBranch.filter(function (el) {
            return el.value === _this.formAdd.masBranchID
          })
          this.formAdd.branchName = dateBranchs[0].text
          // console.log(dateExchange[0].exchangeRate)
          var point =
            parseInt(this.formAdd.amount) / dateExchange[0].exchangeRate
          // console.log(point)
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.point = parseInt(point)
          this.formAdd.lotId = lotId
          this.formAdd.liffId = process.env.VUE_APP_LIFF_ID
          // this.formAdd.statusLot = 'no'
          this.formAdd.shopId = this.$session.getAll().data.shopId
          // this.formAdd.qrCodeURL = 'http://localhost:8081/collect?token=' + this.formAdd.token
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'add',
              this.formAdd
              //   {
              //     headers: {
              //       'Application-Key': this.$session.getAll().ApplicationKey
              //     }
              //   }
            )
            .then(async response => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false
              // this.dataShowQR = true
              // this.dialogViewAdd = true

              // Load Data
              await this.clearData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
          this.loadingAdd = false
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          // this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.id
          this.formUpdateItem.lotName = this.formUpdate.lotName
          this.formUpdateItem.LAST_USER = this.session.data.userName
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdateItem
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
          this.loadingEdit = false
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.id)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.id,
        this.session.data.shopId,
        '&status=waiting',
        this.returnLink
      )
    },
    chkAdd () {
      this.res = []
      axios
        .get(this.DNS_IP + '/only_shop/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data[0].billingPlan
          console.log('rs', rs)
          if (rs === 'billing') {
            alert('billing')
          } else {
            axios
              .get(this.DNS_IP + '/member/Member?shopId=' + this.session.data.shopId)
              .then(response => {
                this.res = response.data
                console.log(this.res)
              })
          }
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = 0
      this.formAdd.point = 0
      this.formAdd.status = 'waiting'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = ''
      this.formAdd.lotId = ''
      this.formAdd.countLot = ''
      this.formAdd.branchName = ''
      this.formAdd.masBranchID = ''
      this.formAdd.lotName = ''
      // eslint-disable-next-line no-redeclare
      // for (var key in this.search) {
      //   if (this.search[key]) {
      //     this.search[key] = ''
      //   }
      // }
    }
  }
}
</script>
<style scoped>
.frameQR {
  background: linear-gradient(to right, black 50%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(black 50%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, black 50%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(black 50%, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 21px 1px, 1px 21px;
  min-width: 170px !important;
}
.shopname {
  font-size: 15px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 15px;
}
.point {
  font-size: 12px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#subtext {
  color: #173053;
  font-size: 20px !important;
  font-weight: bold;
}
#margin {
  margin-top: 30px;
  margin-bottom: 70px;
}
#img_size {
  width: 187.94px;
  height: 385.15px;
  margin-top: 100px;
  margin-left: 100px;
}
.box {
  text-transform: uppercase;
  transition: all .3s;
  position: relative;
  z-index: 1;
  cursor: pointer;
}
.box:hover {
  transform: translateY(-7px);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/CollectQRCodeLot.vue